import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  menuItems: { destination: string, description: string }[] = [
    { destination: '/', description: 'Inicio' },
    { destination: '/productos', description: 'Productos' },
    { destination: '/acerca-de', description: 'Acerca de' }
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
